export const VERTICAL_TESTIDS = {
    casino: 'casino-vertical',
    sports: 'sports-vertical'
};
export const WALLET_TESTID = 'wallet-element';
export const PROFILE_TESTID = 'profile-element';
export const MORE_MENU_TESTID = 'more-menu-element';
export const LOGIN_TESTID = 'login-element';
export const REGISTER_TESTID = 'signup-element';
export const GAMES_TESTID = 'games-element';
export const ODDS_TESTID = 'odds-element';

export const CASUMO_LOGO_TESTID = 'casumo-logo-element';
export const BAR_CONTEXT = 'bar-context';
